var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 64,
    viewBox: "0 0 31 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0323 7.13325C18.3343 3.94632 16.0111 0.709589 15.5365 0.0373468C15.4865 -0.0124489 15.4115 -0.0124489 15.3616 0.0373468C14.8869 0.709589 12.5637 3.94632 9.86574 7.13325C-13.2916 36.5376 13.513 56.3813 13.513 56.3813L13.7378 56.5306C13.9377 59.5932 14.4373 64 14.4373 64H15.4365H16.4358C16.4358 64 16.9354 59.618 17.1352 56.5306L17.36 56.3565C17.385 56.3565 44.1896 36.5376 21.0323 7.13325ZM15.4365 55.933C15.4365 55.933 14.2374 54.9123 13.9127 54.3893V54.3397L15.3616 22.3209C15.3616 22.2213 15.5115 22.2213 15.5115 22.3209L16.9604 54.3397V54.3893C16.6356 54.9123 15.4365 55.933 15.4365 55.933Z",
    fill: "#00684A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.7674,
    height: 64,
    fill: "white",
    transform: "translate(0.440918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMongodb);
export default __webpack_public_path__ + "static/media/icon-mongodb.89e967f4e194a6a9fd3c6496c97be866.svg";
export { ForwardRef as ReactComponent };